<script lang="ts" setup>
const props = defineProps<{
  /** 用户ID */
  id: number
  status?: number
  block?: boolean
}>()

const $toast = useToast()
const $confirm = useConfirm()
const { data: followStatus, refresh: refreshFollowStatus } = useAsyncData(
  `userFollowStatus-${props.id}`,
  () => fetchFollowStatus(props.id),
  {
    lazy: true,
    server: false,
    default: () => props.status || 0
  }
)

const followStatusMap: Record<number, string> = {
  0: '关注',
  1: '已关注',
  2: '互相关注'
}

watch(useUserInfo(), async () => {
  // 监听登录用户信息，如果登录状态变化了，则刷新关注按钮状态
  refreshStatus()
})

function refreshStatus() {
  refreshFollowStatus()
}

function handleClick(e: Event) {
  e.preventDefault()
  e.stopPropagation()

  const { data: userInfo } = useAuth()

  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }

  if (userInfo.value.user.id == props.id) {
    $toast.success('你每时每刻都在关注着自己')
    return
  }

  switch (followStatus.value) {
    case 0:
      requestFollow(props.id)
        .then((res) => {
          refreshStatus()
          if (res.code !== 1) {
            $toast.error(res.msg)
          } else {
            $toast.success('关注成功')
            refreshStatus()
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            useEmitter().emit('requestLogin')
          }
        })
      break
    case 1:
    case 2:
      $confirm('确认', '确定取消关注吗？', {
        onConfirm: () => {
          requestUnfollow(props.id).then(() => {
            $toast.success('已取消关注')
            refreshStatus()
          })
        }
      })
  }
}
</script>

<template>
  <button
    size="medium"
    class="m-follow-button"
    :class="{
      isSubscribed: !!followStatus,
      block
    }"
    @click="handleClick"
  >
    {{ followStatusMap[followStatus || 0] }}
  </button>
</template>

<style lang="scss" scoped>
.m-follow-button {
  cursor: pointer;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  width: 86px;
  height: 34px;
  border-radius: 4px;
  background-color: var(--color-primary);
  color: #fff;
  &.isSubscribed {
    background-color: #f4f5f5;
    color: #777c82;
  }
  &.block {
    width: 100%;
  }
}
</style>
